import React, { useCallback, useState } from 'react';

import { Container, ErrorMessage, DetailMessage } from './styles';

type InputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
    label: string;
    error?: string | null;
    Icon?: React.ReactNode;
    maxLength?: number;
    hasError?: (error: boolean) => void;
}

const Input: React.FC<InputProps> = ({ hasError, onChange, label, error, Icon, required, maxLength, value, ...rest }) => {
    const [isCharacterlimitExceeded, setCharacterlimitExceeded] = useState<boolean>(false);

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        const isCharacterlimitExceeded = !!maxLength && String(value || '').length > maxLength;
        setCharacterlimitExceeded(isCharacterlimitExceeded);
        hasError?.(isCharacterlimitExceeded);
        onChange?.(e);
    }, [hasError, onChange, maxLength]);

    return (
        <Container $error={!!error}>
            <label>
                {label}
                {required && (
                    <span>*</span>
                )}
            </label>
            {Icon ? (
                <div>
                    <input
                        {...rest}
                        value={value}
                        onChange={handleChange}
                    />
                    {Icon}
                </div>
            ) : (
                <input
                    {...rest}
                    value={value}
                    onChange={handleChange}
                />
            )}
            {maxLength && (
                <DetailMessage $characterlimitExceeded={isCharacterlimitExceeded}>
                    {`${String(value || '').length}/${maxLength} caracteres${isCharacterlimitExceeded ? '. Limite de caractere atingido' : ''}`}
                </DetailMessage>
            )}
            {error && (
                <ErrorMessage>{error}</ErrorMessage>
            )}
        </Container>
    );
};

export { Input };
export type { InputProps };